export default __webpack_public_path__ + "static/media/mei-ult.d026f0ed.mp3";